<template>
  <div class="inventoryTransfer">
    <!-- 转库单 -->
    <baseBreadcrumb :page="$t('message.transferOrder')" :menu="$t('message.inventoryTransfer')"></baseBreadcrumb>
    <div class="body">
      <!--  -->
      <div class="tabs">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleClickTab">
          <!-- 待装箱  -->
          <el-tab-pane :label="`${$t('message.toEncasement')}(${tabCount.pending})`" name="0">
          </el-tab-pane>
          <!-- 装箱中  -->
          <el-tab-pane :label="`${$t('message.thePacking')}(${tabCount.packing})`" name="1">
          </el-tab-pane>
          <!-- 装箱完成待入仓   -->
          <el-tab-pane :label="`${$t('message.charge_wms')}(${tabCount.packCompleted})`" name="2">
          </el-tab-pane>

        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 客户ID-->
          <div class="item">
            <el-input :placeholder="$t('message.clientID')" v-model="datas.user_id"></el-input>
          </div>
          <!-- 物流号 -->
          <div class="item">
            <el-input :placeholder="$t('message.logisticsNumber')" v-model="datas.purchase_no"></el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <el-input :placeholder="$t('message.transactionNumber')" v-model="datas.express_no"></el-input>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <el-input :placeholder="$t('message.orderNumber')" v-model="datas.order_sn"></el-input>
          </div>
          <!-- 提出人 -->
          <div class="item">
            <el-select v-model="datas.created_by" clearable filterable :placeholder="$t('message.peoplePutForward')">
              <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 装箱操作人 -->
          <div class="item">
            <el-select v-model="datas.pack_by" clearable filterable :placeholder="$t('message.packBy')">
              <el-option v-for="item in z" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索按钮 -->
          <div class="item">
            <el-button type="primary" @click="handleClickTab">
              {{ $t('message.search') }}
            </el-button>
            <!-- 重置按钮 -->
            <el-button @click="reset">
              {{ $t('message.reset') }}
            </el-button>
          </div>
        </div>
        <div class="row" style="margin:20px 0px;">
          <!--  操作-->
          <div class="btn">
            <!-- 转库单合并 -->
            <el-button type="primary" class="primary" v-if="activeTab == 0" @click="mergeTransferOrder">
              {{ $t('message.mergeTransferOrder') }}
            </el-button>
            <!--取消转库  -->
            <el-button type="primary" v-if="activeTab == 0" @click="cancelTransferOrder">
              {{ $t('message.cancelTransferOrder') }}
            </el-button>
            <!--取消装箱  -->
            <el-button type="primary" v-if="activeTab == 1" @click="cancelPacking">
              {{ $t('message.cancelPacking') }}
            </el-button>
            <!-- 上架到长存仓库 -->
            <el-button type="primary" class="primary" v-if="activeTab == 2" @click="uploadToLongTermStorageWarehouse">
              {{ $t('message.uploadToLongTermStorageWarehouse') }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 已完成列表 -->
      <div class="table" v-if="activeTab == 2">
        <div class="tableHeader">
          <div class="item flex05">
            <el-checkbox v-model="checked" @change="handleCheckAllChange"></el-checkbox>
          </div>
          <!--No-->
          <div class="item flex05">No</div>
          <!--客户信息 -->
          <div class="item">{{ $t('message.userInfo') }}</div>
          <!-- 箱号 -->
          <div class="item">{{ $t('message.boxNums') }}</div>
          <!-- 装箱完成时间 -->
          <div class="item">{{ $t('message.packCompleteTime') }}</div>
          <!-- 箱内SKU数 -->
          <div class="item">{{ $t('message.boxInnerSKUNum') }}</div>
          <!-- 箱内商品数 -->
          <div class="item">{{ $t('message.boxInnerGoodsNum') }}</div>
          <!-- 实际重量 -->
          <div class="item">{{ $t('message.actualWeight') }}</div>
          <!-- 箱子尺寸 -->
          <div class="item">{{ $t('message.boxSize') }}</div>
          <!-- 箱内商品价值.元 -->
          <div class="item">{{ $t('message.boxInnerGoodsValue') }}</div>
          <!-- 客户对应人 -->
          <div class="item">{{ $t('message.customerCorrespondingPerson') }}</div>
          <!-- 装箱操作人 -->
          <div class="item">{{ $t('message.packBy') }}</div>
        </div>
        <div class="tableBody" v-for="(item, index) in tableData" :key="index">
          <div class="tableRow">
            <div class="item flex05">
              <el-checkbox v-model="item.checked" @change="handleCheckChange"></el-checkbox>
            </div>
            <div class="item flex05">{{ item.rowNumber }}</div>
            <!--客户信息 -->
            <div class="item">
              <div>
                <p>
                  ID：{{ item.user_id }}
                </p>
                {{ item.wms_move ? item.wms_move.user.realname : '' }}
              </div>
            </div>
            <!-- 箱号 -->
            <div class="item">
              <p> {{ item.move_sn }}-{{ item.box_no }}</p>
              <p style="margin-top: 10px;" class="isShow">
                <!-- 展开收起 -->
                <el-button type="info" @click="item.show = !item.show" size="mini">{{ item.show ?
                  $t('message.collapse') :
                  $t('message.expandCollapse') }}
                  <i v-if="!item.show" class="el-icon-arrow-down"></i>
                  <i v-else class="el-icon-arrow-up"></i>
                </el-button>
              </p>
            </div>
            <!-- 装箱完成时间 -->
            <div class="item">{{ item.complete_at }}</div>
            <!-- 箱内SKU数 -->
            <div class="item">{{ item.sku_count }}</div>
            <!-- 箱内商品数 -->
            <div class="item">{{ item.total_num }}</div>
            <!-- 实际重量 -->
            <div class="item">{{ item.weight }}</div>
            <!-- 箱子尺寸 -->
            <div class="item">{{ item.attr }}</div>
            <!--  箱内商品价值.元-->
            <div class="item">{{ item.goods_amount }}</div>
            <!-- 客户对应人 -->
            <div class="item">
              <div class="template">
                <!--  业务 -->
                <p style="margin-bottom: 5px;">
                  {{ $t('message.business') }}：{{ item.wms_move ? item.wms_move.user.y_admin.realname : '' }}
                </p>
                <!--  采购 -->
                <p style="margin-bottom: 5px;">
                  {{ $t('message.purchase') }}：{{ item.wms_move ? item.wms_move.user.g_admin.realname : '' }}
                </p>
                <!--   配货 -->
                <p>
                  {{ $t('message.distribution') }}：{{ item.wms_move ? item.wms_move.user.p_admin.realname : '' }}
                </p>
              </div>
            </div>
            <!-- 装箱操作人 -->
            <div class="item">{{ item.wms_move.pack_by_admin.realname }}</div>
          </div>
          <el-collapse-transition>
            <div class="commodity" v-show="item.show">
              <ol>
                <!-- 订单号 -->
                <li>{{ $t('message.orderNumber') }}</li>
                <!-- 番号 -->
                <li>{{ $t('message.mash') }}</li>
                <!-- 商品属性 -->
                <li>{{ $t('message.commodityAttribute') }}</li>
                <!-- 图片 -->
                <li>{{ $t('message.pic') }}</li>
                <!-- 数量 -->
                <li>{{ $t('message.quantity') }}</li>
              </ol>
              <ul v-for="(order, orderIndex) in item.details" :key="orderIndex">
                <!-- 订单号 -->
                <li>
                  <router-link :to="`/orderPaymentDetail?order_sn=${order.order_sn}`" target="_blank" class="a-link">
                    {{ order.order_sn }}
                  </router-link>
                </li>
                <!-- 番号 -->
                <li>{{ order.sorting }}</li>
                <!-- 商品属性 -->
                <li>
                  <div class="template">
                    <p v-for="(attr, attrIndex) in order.detail_y" :key="attrIndex">
                      {{ attr.key }}:{{ attr.value }}
                    </p>
                  </div>
                </li>
                <!-- 图片 -->
                <li>
                  <el-popover placement="right" width="300" trigger="hover">
                    <el-image :src="order.pic" style="width: 300px; height: 300px;" />
                    <a :href="order.link.goods_url" target="_blank" rel="noopener" slot="reference">
                      <el-image :src="order.pic" fit="fill" style="width: 60px; height: 60px;" />
                    </a>
                  </el-popover>
                </li>
                <!-- 数量 -->
                <li>{{ order.num }}</li>
              </ul>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <!-- 待装箱 装箱中 -->
      <div class="table" v-else>
        <ol style="background-color: #EDEFF4;">
          <li class="flex05">
            <el-checkbox v-model="checked" @change="handleCheckAllChange"></el-checkbox>
          </li>
          <li class="flex05">No</li>
          <!-- 提出人 -->
          <li>{{ $t('message.peoplePutForward') }}</li>
          <!-- 装箱操作人 -->
          <li>{{ $t('message.packBy') }}</li>
          <!-- 待打包转库单 -->
          <li class="flex2">{{ $t('message.pendingTransferOrder') }}</li>
          <!-- 客户信息 -->
          <li>{{ $t('message.userInfo') }}</li>
          <!-- 客户对应人-->
          <li>{{ $t('message.customerCorrespondingPerson') }}</li>
          <!-- 操作商品番数 -->
          <li>{{ $t('message.operationProductSerialNumber') }}</li>
          <!-- 操作商品数量 -->
          <li>{{ $t('message.operationProductQuantity') }}</li>
          <!--  提出转库时间-->
          <li>{{ $t('message.proposeTransferTime') }}</li>
          <!-- 当前商品所在仓库 -->
          <li>{{ $t('message.currentWarehouse') }}</li>
          <!-- 目标仓库 -->
          <li>{{ $t('message.targetWarehouse') }}</li>
          <!-- 整单操作备注 -->
          <li>{{ $t('message.entireOrderOperationRemark') }}</li>
          <!-- 单子状态 -->
          <li>{{ $t('message.subOrderStatus') }}</li>
          <!-- 装箱完成时间 -->
          <li>{{ $t('message.packCompleteTime') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="handleCheckChange"></el-checkbox>
          </li>
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 提出人 -->
          <li>{{ item.created_by_admin ? item.created_by_admin.realname : '' }}</li>
          <!-- 装箱操作人 -->
          <li>{{ item.pack_by_admin ? item.pack_by_admin.realname : '' }}</li>
          <!-- 待打包转库单 -->
          <li class="flex2">
            <router-link :to="`/transferOrderDetail?move_sn=${item.move_sn}`" target="_blank" class="a-link"
              style="color: #B4272D;">
              {{ item.move_sn }}
            </router-link>

          </li>
          <!-- 客户信息 -->
          <li>
            <div>
              <p>
                ID：{{ item.user_id }}
              </p>
              {{ item.user ? item.user.realname : '' }}
            </div>
          </li>
          <!-- 客户对应人-->
          <li>
            <div class="template">
              <!--  业务 -->
              <p style="margin-bottom: 5px;">
                {{ $t('message.business') }}：{{ item.user.y_admin ? item.user.y_admin.realname : '' }}
              </p>
              <!--  采购 -->
              <p style="margin-bottom: 5px;">
                {{ $t('message.purchase') }}：{{ item.user.g_admin ? item.user.g_admin.realname : '' }}
              </p>
              <!--   配货 -->
              <p>
                {{ $t('message.distribution') }}：{{ item.user.p_admin ? item.user.p_admin.realname : '' }}
              </p>
            </div>
          </li>
          <!-- 操作商品番数 -->
          <li>
            <el-link type="primary" :underline="false" @click="handleClickLink(item)">
              {{ item.total_count }}
            </el-link>
          </li>
          <!-- 操作商品数量 -->
          <li>
            <el-link type="primary" :underline="false" @click="handleClickLink(item)">
              {{ item.total_num }}
            </el-link>
          </li>
          <!--  提出转库时间-->
          <li>{{ item.created_at }}</li>
          <!-- 当前商品所在仓库 -->
          <li>常规商品仓库</li>
          <!-- 目标仓库 -->
          <li>{{ item.target_shelf_type_name }}</li>
          <!-- 整单操作备注 -->
          <li>
            <p>{{ item.remark }}</p>
          </li>
          <!-- 单子状态 -->
          <li>{{ item.status_name }}</li>
          <!-- 装箱完成时间 -->
          <li>{{ item.complete_pack_at }}</li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[200, 300, 400]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看详情 -->
    <lookDetail ref="lookDetail" />
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :up_data="ids" :type="7" :shelf_type_set="[4,]" />
  </div>
</template>
<script>
import lookDetail from './components/lookDetail.vue'
import warehouse from "@/components/common/warehouse";
export default {
  components: {
    lookDetail,
    warehouse
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    z() {
      return this.$store.state.authWorkGroupAdmin.z;
    },
  },
  data() {
    return {
      warehouseDialogVisible: false,
      ids: [],
      activeTab: '0',
      datas: {
        user_id: '',
        purchase_no: '',
        express_no: '',
        order_sn: '',
        created_by: '',
        pack_by: '',
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      adminList: [],
      total: 0,
      checked: false,
      tabCount: {
        packCompleted: 0,
        packing: 0,
        pending: 0,
      },//tab数量
    }
  },
  created() {
    this.handleClickTab();
    // 获取所有人员
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      this.adminList = res.data.data
    })

  },
  methods: {
    // 转库订单tab数量
    tabCountTable() {
      this.$api.inventoryTransferApi.tabCount().then(res => {
        this.tabCount = res.data
      })
    },
    // 点击tab
    handleClickTab() {
      this.datas.page = 1;
      this.tableData = [];
      this.checked = false;
      if (this.activeTab == 2) {
        this.listCompleteBoxs();
      } else {
        this.moveList();
      }
      this.tabCountTable()
    },
    // 已装箱完成
    listCompleteBoxs() {
      this.$api.inventoryTransferApi.listCompleteBoxs(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false;
          item.show = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 待打包转库单
    moveList() {
      this.datas.status = this.activeTab;
      this.$api.inventoryTransferApi.moveList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false;
          item.show = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: '',
        purchase_no: '',
        express_no: '',
        order_sn: '',
        created_by: '',
        pack_by: '',
        page: 1,
      }
      this.handleClickTab();
    },
    // 分页-每页数量改变时
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.handleClickTab();
    },
    // 分页-当前页改变时
    handleCurrentChange(val) {
      this.datas.page = val;
      if (tab.name == 2) {
        this.listCompleteBoxs();
      } else {
        this.moveList();
      }
    },
    // 全选
    handleCheckAllChange() {
      this.tableData.forEach(item => {
        item.checked = this.checked;
      })
    },
    // 复选框改变时
    handleCheckChange() {
      this.checked = this.tableData.every(item => item.checked);
      this.$forceUpdate();
    },
    // 点击链接
    handleClickLink(item) {
      this.$api.inventoryTransferApi.goodsList({
        move_sn: item.move_sn,
      }).then(res => {
        this.$refs.lookDetail.list = res.data
        this.$refs.lookDetail.dialogVisible = true;
      })
    },
    // 转库单合并
    mergeTransferOrder() {
      // 获取选中的转库单
      const selectedOrders = this.tableData.filter(item => item.checked);

      // 检查是否有选中的转库单
      if (selectedOrders.length === 0) {
        this.$message.warning('请勾选同一个客户转库单进行操作');
        return;
      }

      // 检查是否属于同一个客户
      const firstUserId = selectedOrders[0].user_id;
      const isSameUser = selectedOrders.every(item => item.user_id === firstUserId);

      if (!isSameUser) {
        this.$message.warning('请勾选同一个客户转库单进行操作');
        return;
      }
      // 构建合并请求数据
      const mergeData = {
        move_sns: selectedOrders.map(item => item.move_sn),
      };
      // 调用合并转库单接口
      this.$api.inventoryTransferApi.mergeMove(mergeData).then(res => {
        this.$message.success(res.message || '转库单合并成功');
        // 重新加载数据
        this.handleClickTab();

      })
    },
    // 取消转库单
    cancelTransferOrder() {
      // 获取选中的转库单
      const selectedOrders = this.tableData.filter(item => item.checked);

      // 检查是否有选中的转库单
      if (selectedOrders.length === 0) {
        this.$message.warning('请勾选转库单进行操作');
        return;
      }

      // 构建取消请求数据
      const cancelData = {
        move_sns: selectedOrders.map(item => item.move_sn),
      };
      let moveSnStr = selectedOrders.map(item => item.move_sn).join('<br>');
      moveSnStr = `<div style="border-radius: 6px; padding: 12px;background: #F6F6F6;line-height: 25px;color: #B4272D;margin-top: 12px;text-align: left;">` + moveSnStr + `</div>`
      this.$confirm('是否取消当前已勾选的转库单?<br>取消后转库单不在保留，后续需要重新提出？<br>' + moveSnStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        center: true,
        confirmButtonText: '确定取消',
        cancelButtonText: '关闭',
      }).then(() => {
        // 调用取消转库单接口
        this.$api.inventoryTransferApi.batchCancel(cancelData).then(res => {
          this.$message.success(res.message || '转库单取消成功');
          // 重新加载数据
          this.handleClickTab();

        })
      }).catch(() => {

      });
    },
    // 上架到长存仓库
    uploadToLongTermStorageWarehouse() {
      // 获取选中的转库单
      const selectedOrders = this.tableData.filter(item => item.checked);

      // 检查是否有选中的转库单
      if (selectedOrders.length === 0) {
        this.$message.warning('请勾选转库单进行操作');
        return;
      }
      this.ids = selectedOrders.map(item => item.id);
      console.log(this.ids);

      this.warehouseDialogVisible = true;
    },
    // 取消装箱
    cancelPacking() {
      // 获取选中的转库单
      const selectedOrders = this.tableData.filter(item => item.checked);

      // 检查是否有选中的转库单
      if (selectedOrders.length === 0) {
        this.$message.warning('请勾选转库单进行操作');
        return;
      }
      // 检查是否有选中的转库单
      if (selectedOrders.length > 1) {
        this.$message.warning('请勾选一个转库单进行操作');
        return;
      }
      // 构建取消请求数据
      const backToPendingData = {
        move_sn: selectedOrders[0].move_sn,
      };
      this.$api.inventoryTransferApi.backToPending(backToPendingData).then(res => {
        this.$message.success(res.message || '转库单取消成功');
        // 重新加载数据
        this.handleClickTab();

      })
    }
  }
}
</script>
<style scoped lang="scss">
.inventoryTransfer {
  .search {
    .row {
      display: flex;
      margin-top: 10px;

      .item {
        width: 200px;
        margin-right: 20px;

        .el-date-editor {
          width: 100%;
        }
      }

      .btn {
        margin-left: auto;
      }
    }
  }

  .table {
    .tableHeader {
      display: flex;
      line-height: 20px;
      height: 56px;
      color: #666666;
      background-color: #EDEFF4;
    }

    .tableBody {
      .tableRow {
        display: flex;
        background-color: #fff;
        padding: 30px 0;
        justify-content: center;
        align-items: center;
      }

    }

    .item {
      flex: 1;
      text-align: center;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .isShow {
      text-align: left;

      .el-button {
        background-color: #F6F6F6;
        border: none;
        color: #999999;
        padding: 6px 10px;

        i {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>